var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaleImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_89191)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_62_89191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.101 36.9398L27.9015 35.2048L21.9128 35.2916L16.1263 35.2048L11.9268 36.9398C11.9268 36.9398 12.2636 41.9566 21.9128 42H22.07C31.7192 41.9277 32.101 36.9398 32.101 36.9398Z",
    fill: "#F5C5AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0986 41.3493C20.3773 41.3493 18.7265 40.689 17.5093 39.5136C16.2922 38.3382 15.6084 36.7441 15.6084 35.0819V21.7373H28.5888V35.0819C28.5888 36.7441 27.905 38.3382 26.6878 39.5136C25.4707 40.689 23.8199 41.3493 22.0986 41.3493Z",
    fill: "#F5C5AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6084 25.981C15.6084 25.981 19.1716 32.3858 23.2589 32.0749C29.5694 31.5906 28.4989 24.0364 28.4989 24.0364C28.4989 24.0364 26.0511 29.0966 22.1809 29.0966C20.9138 29.0854 19.6654 28.7996 18.5279 28.2604C17.3903 27.7211 16.3926 26.9422 15.6084 25.981Z",
    fill: "#F0AF91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4344 17.1182L11.7832 10.7784C10.9373 6.72301 14.2086 4.58325 17.0682 4.58325H26.9868C30.0186 4.58325 33.6417 6.70855 32.0996 11.2772L31.2163 18.1808L12.4344 17.1182Z",
    fill: "#202C45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5416 20.5883C32.5104 21.9907 35.909 15.6148 33.9926 14.0823C32.0762 12.5497 30.8111 15.3401 30.8111 15.3401L30.7662 17.6823L30.4818 19.8509L30.377 20.5232L30.5416 20.5883Z",
    fill: "#F5C5AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4612 16.0268C33.4612 16.0268 32.0389 15.5714 31.0283 17.5954",
    stroke: "#F0AF91",
    strokeWidth: 0.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7188 16.6262C31.7188 16.6262 33.2683 17.4286 32.2428 18.6286",
    stroke: "#F0AF91",
    strokeWidth: 0.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.378 20.5878C11.4092 21.9902 8.01066 15.6143 9.92703 14.0818C11.8434 12.5492 13.0486 15.3685 13.0486 15.3685L13.1833 17.7107L13.4678 19.8793L13.5801 20.5516L13.378 20.5878Z",
    fill: "#F5C5AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.459 16.0268C10.459 16.0268 11.8813 15.5714 12.8919 17.5954",
    stroke: "#F0AF91",
    strokeWidth: 0.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2019 16.6262C12.2019 16.6262 10.6524 17.4286 11.6779 18.6286",
    stroke: "#F0AF91",
    strokeWidth: 0.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1861 12.3614C31.1847 15.6472 30.8208 18.9235 30.1007 22.1348C29.567 24.5153 28.0785 26.5947 25.961 27.918L25.5792 28.1637C24.481 28.8524 23.2026 29.2256 21.8932 29.2397C20.5838 29.2537 19.2971 28.9082 18.1833 28.2433C17.0525 27.5712 16.0791 26.679 15.3251 25.6236C14.5711 24.5681 14.0531 23.3726 13.8041 22.1132C13.2298 18.8899 12.8971 15.6308 12.8085 12.3614C12.8085 12.3614 11.9551 2.39994 21.8663 2.59512C31.7775 2.7903 31.1861 12.3614 31.1861 12.3614Z",
    fill: "#F5C5AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3214 1.06974C28.1549 -1.07725 21.9491 0.426363 18.5581 1.92997C18.6254 0.946844 18.0041 1.05528 18.0041 1.05528C12.0155 2.60226 13.6025 7.14201 13.6025 7.14201H13.6624C13.041 8.45044 12.2326 11.2336 12.9961 16.2721C12.9961 16.2721 14.5756 10.8215 14.6205 7.59743C17.263 8.72514 24.5243 11.4649 29.2553 9.93237C29.6776 12.0894 30.2478 14.217 30.9621 16.301C31.3798 13.9262 31.362 11.4989 30.9097 9.12996C31.2061 8.93218 31.4818 8.70703 31.7331 8.45767C31.7331 8.45767 35.7829 4.12033 31.3214 1.06974Z",
    fill: "#202C45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1328 17.1887V20.4056C21.1339 20.5118 21.1541 20.617 21.1927 20.7164C21.2764 20.8949 21.4238 21.0383 21.608 21.1206C21.7921 21.2029 22.0007 21.2185 22.1958 21.1646L23.0567 20.9405",
    stroke: "#202C45",
    strokeWidth: 0.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8316 17.1233C18.307 17.1233 18.6924 16.7511 18.6924 16.292C18.6924 15.8329 18.307 15.4607 17.8316 15.4607C17.3561 15.4607 16.9707 15.8329 16.9707 16.292C16.9707 16.7511 17.3561 17.1233 17.8316 17.1233Z",
    fill: "#202C45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7954 17.1233C26.2709 17.1233 26.6563 16.7511 26.6563 16.292C26.6563 15.8329 26.2709 15.4607 25.7954 15.4607C25.32 15.4607 24.9346 15.8329 24.9346 16.292C24.9346 16.7511 25.32 17.1233 25.7954 17.1233Z",
    fill: "#202C45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4648 22.7476C20.1879 23.1346 21.0145 23.3033 21.8378 23.2319C22.7227 23.2562 23.6022 23.0908 24.413 22.7476",
    stroke: "#202C45",
    strokeWidth: 0.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9121 26.2195V27.1231",
    stroke: "#F0AF91",
    strokeWidth: 0.39,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0096 14.3909L20.047 12.7644L16.9254 12.8222C16.534 12.8292 16.1566 12.9643 15.8549 13.2054L14.6123 14.5861L16.6784 14.2897L20.0096 14.3909Z",
    fill: "#202C45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6641 14.3909V12.7644L26.7782 12.8222C27.1694 12.8304 27.5464 12.9653 27.8486 13.2054L29.0838 14.5861L27.0252 14.2897L23.6641 14.3909Z",
    fill: "#202C45"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_62_89191",
    x: 7.36035,
    y: -1,
    width: 27.1992,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.215686 0 0 0 0 0.211765 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_62_89191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_62_89191",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_89191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleImg);
export default __webpack_public_path__ + "static/media/male-img.e42dfecd4826fc035fae965a9fca7979.svg";
export { ForwardRef as ReactComponent };